import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var PLAN_KEY = "postPlanAdminPlan";
var COVER_TYPE_KEY = "postPlanAdminCoverType";
var COVER_TYPE_PLAN_KEY = "postPlanAdminCoverTypePlan";
export var useCreatePlan = function () {
    var dispatch = useDispatch();
    var plan = useRequestState(PLAN_KEY);
    var coverType = useRequestState(COVER_TYPE_KEY);
    var coverTypePlan = useRequestState(COVER_TYPE_PLAN_KEY);
    var post = function (requestKey, path, body) {
        dispatch(customRequestApis({
            requestKey: requestKey,
            method: "POST",
            path: path,
            body: { data: body },
        }));
    };
    var createPlan = function (body) {
        return post(PLAN_KEY, "/asg/Api/V1/Plan", body);
    };
    var createCoverType = function (body) {
        return post(COVER_TYPE_KEY, "/asg/Api/V1/CoverType", body);
    };
    var createCoverTypePlan = function (body) {
        return post(COVER_TYPE_PLAN_KEY, "/asg/Api/V1/CoverTypePlan", body);
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(PLAN_KEY));
            dispatch(clearCustomRequest(COVER_TYPE_KEY));
            dispatch(clearCustomRequest(COVER_TYPE_PLAN_KEY));
        };
    }, []);
    return {
        createPlan: createPlan,
        createCoverType: createCoverType,
        createCoverTypePlan: createCoverTypePlan,
        createdPlan: plan.data,
        createdCoverType: coverType.data,
        createdCoverTypePlan: coverTypePlan.data,
        loadingCreate: plan.loading || coverType.loading || coverTypePlan.loading,
        errorCreatePlan: plan.error,
        errorCreateCoverType: coverType.error,
        errorCreateCoverTypePlan: coverTypePlan.error,
        clearCreatedPlan: function () { return dispatch(clearCustomRequest(PLAN_KEY)); },
        clearCreatedCoverType: function () { return dispatch(clearCustomRequest(COVER_TYPE_KEY)); },
        clearCreatedCoverTypePlan: function () {
            return dispatch(clearCustomRequest(COVER_TYPE_PLAN_KEY));
        },
    };
};
